import { useState, useEffect } from "react";
import { GetDepartmentList } from "services/other/department.service";
import { GetEmployeeNameList } from "services/employee/employee.service";
import { GetUnits } from 'services/user/user.service';
import { useSelector, useDispatch } from "react-redux";

const useItemDropdown = () => {
    const dispatch = useDispatch();
    
    const { departmentList } = useSelector((state) => state.departmentList);
    const { employeeNameList } = useSelector((state) => state.employeeNameList);
    const { unitList } = useSelector((state) => state.units);

    const [departmentDropdown, setDepartmentDropdown] = useState([]);
    const [employeeNameDropdown, setEmployeeNameDropdown] = useState([]);
    const [unitListDropdown, setUnitListDropdown] = useState([]);

    useEffect(() => {
        dispatch(GetDepartmentList());
        dispatch(GetEmployeeNameList());
        dispatch(GetUnits());
    }, []);

    return {
        departmentDropdown, 
        setDepartmentDropdown, 
        employeeNameDropdown,
        setEmployeeNameDropdown,
        unitListDropdown,
        setUnitListDropdown,
        departmentList,
        employeeNameList,
        unitList,
    };
};

export default useItemDropdown;
